import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { createCustomPropType, isNumeric } from '../../../../../js/app/react/validators';
import SimpleSelect from '../../../SimpleSelect/SimpleSelectView';
import AdvForm from '../../../../CommonComponents/AdvForm';
import InputDollar from '../../../InputDollar/InputDollarView';
import Input, { LEFT } from '../../../Input/InputView';
import ButtonWithLoading from '../../../ButtonWithLoading/ButtonWithLoadingContainer';
import Validation from '../../../Validation/ValidationContainer';
import {
  BACKEND_KEY,
  DOLLAR_CONTRIBUTION,
  NO_CONTRIBUTION,
  PERCENTAGE_CONTRIBUTION,
} from '../../AccountsWorkflowConstants';
import BackMobileNavigation from '../../../BackMobileNavigation/BackMobileNavigationView';
import { RothBalances } from '../../components/RothBalances';
import { Contributions } from '../../components/Contributions';
import { ACCOUNTS_WITH_HOLDINGS_TAB } from '../../../../Profile/Accounts/Features/AccountPreferences/components/AccountForm/AccountForm.meta';
import { parsePositionValue } from '../../../../Profile/Accounts/Features/AccountPreferences/components/AccountForm/utils/parsePositionValue';
import { Box } from '../../../../CommonComponents/OPL/Box/Box';
import { formatCurrency } from '../../../../CommonUtils/formatNumber';

class AccountAddEditView extends Component {
  componentDidMount() {
    const {
      account,
      workflowId,
      clientId,
      mapEmployerMatch,
      isEmployerMatchableRetirementAccount,
    } = this.props;

    if (isEmployerMatchableRetirementAccount) {
      mapEmployerMatch(account, workflowId, clientId);
    }
  }

  render() {
    const {
      workflowId,
      clientId,
      onCancel,
      onSave,
      accountInputChanged,
      accountSimpleSelectChanged,
      accountTypeChanged,
      contributionTypeChanged,
      graphAccounts,
      groups,

      account,
      contributionType,

      accountTypeOption,
      accountTypesOptions,

      accountOwnerOption,
      accountOwnersOptions,
      accountOwnersGroups,

      contributionLabel,
      dollarContributionKeyName,

      percentageContributionTitle,
      percentageContributionKeyName,

      isEmployerMatchableRetirementAccount,

      hasMaximizeContributions,
      contributionPeriod,
      hasContributionPeriodOption,
      canEmployeeMaxContribution,
      hasContributionPercentOption,

      updateDraftAccount,
      accountTypes,
    } = this.props;

    const showMarketValueBreakdown =
      ACCOUNTS_WITH_HOLDINGS_TAB.includes(account.AccountType) &&
      parsePositionValue(account.SpecificPositionsValue) > 0;

    const nonSpecificPositionsValueInput = (
      <InputDollar
        maxLength="256"
        placeholder={showMarketValueBreakdown ? 'Non-Specific Holdings' : 'Account Value'}
        className="accounts"
        isLeftAligned
        value={account.NonSpecificPositionsValue}
        id={showMarketValueBreakdown ? 'adv-non-specific-holdings' : 'adv-account-value'}
        onChange={accountInputChanged('NonSpecificPositionsValue', workflowId, clientId)}
      />
    );

    return (
      <AdvForm className="AccountAddEditView with-mobile-top-padding">
        <BackMobileNavigation
          label="Add Account"
          onBack={onCancel(workflowId, clientId, account, graphAccounts)}
        />
        <Validation workflowId={workflowId} validationId={`${BACKEND_KEY}.AccountAddEdit`} />
        <h2 className="h2">Please add your account information.</h2>
        <ul className="form-input-list">
          <li className="form-input">
            <SimpleSelect
              placeholder="Account Type"
              id="adv-account-type"
              className="no-horizontal-scroll sm"
              value={accountTypeOption}
              isLeftAligned
              options={accountTypesOptions}
              groups={groups}
              onValueChange={accountTypeChanged(workflowId, clientId)}
            />
          </li>
          <li className="form-input">
            <SimpleSelect
              placeholder="Owner"
              id="adv-owner"
              className="no-horizontal-scroll sm"
              value={accountOwnerOption}
              options={accountOwnersOptions}
              isLeftAligned
              groups={accountOwnersGroups}
              onValueChange={accountSimpleSelectChanged('AccountOwner', workflowId, clientId)}
            />
          </li>
          <li className="form-input">
            {showMarketValueBreakdown ? (
              <Box width={240} display="flex" flexDirection="column" ml={28}>
                <InputDollar
                  disabled
                  maxLength="256"
                  placeholder="Specific Holdings"
                  className="accounts"
                  isLeftAligned
                  id="adv-specific-holdings"
                  value={account.SpecificPositionsValue}
                />

                <Box mt="40">{nonSpecificPositionsValueInput}</Box>

                <Box>
                  <p
                    style={{ position: 'relative', textAlign: 'left' }}
                    className="adv-workflow-input-placeholder-left"
                  >
                    Total Current Market Value
                  </p>
                  <p style={{ textAlign: 'left', fontWeight: 600 }}>
                    {formatCurrency(
                      parsePositionValue(account.SpecificPositionsValue) +
                        parsePositionValue(account.NonSpecificPositionsValue),
                    )}
                  </p>
                </Box>
              </Box>
            ) : (
              nonSpecificPositionsValueInput
            )}
          </li>
          <li className="form-input">
            <Input
              type="text"
              maxLength="256"
              alignment={LEFT}
              id="adv-account-description"
              placeholder="Account Description"
              className="nickname"
              value={account.AccountName}
              readOnly={account.IsOrion}
              onChange={accountInputChanged('AccountName', workflowId, clientId)}
            />
          </li>

          <RothBalances
            account={account}
            updateAccount={updateDraftAccount}
            accountTypes={accountTypes}
          />

          {(contributionType === DOLLAR_CONTRIBUTION ||
            contributionType === PERCENTAGE_CONTRIBUTION) && (
            <Contributions
              account={account}
              contributionType={contributionType}
              hasContributionPeriodOption={hasContributionPeriodOption}
              contributionLabel={contributionLabel}
              accountInputChanged={accountInputChanged}
              workflowId={workflowId}
              clientId={clientId}
              contributionPeriod={contributionPeriod}
              hasMaximizeContributions={hasMaximizeContributions}
              canEmployeeMaxContribution={canEmployeeMaxContribution}
              dollarContributionKeyName={dollarContributionKeyName}
              percentageContributionTitle={percentageContributionTitle}
              percentageContributionKeyName={percentageContributionKeyName}
              hasContributionPercentOption={hasContributionPercentOption}
              isEmployerMatchableRetirementAccount={isEmployerMatchableRetirementAccount}
              updateDraftAccount={updateDraftAccount}
              contributionTypeChanged={contributionTypeChanged}
              accountTypeOption={accountTypeOption}
            />
          )}
        </ul>

        <div className="footer">
          <button
            type="button"
            className="adv-workflow-navigation-cancel-button"
            onClick={onCancel(workflowId, clientId, account, graphAccounts)}
          >
            Cancel
          </button>
          <ButtonWithLoading
            workflowId={workflowId}
            type="button"
            className="adv-workflow-navigation-next-save-button"
            onClick={onSave(
              {
                ...(hasContributionPeriodOption
                  ? { ...account, ContributionPeriod: contributionPeriod }
                  : account),
              },
              graphAccounts,
              workflowId,
              clientId,
            )}
          >
            Save Account
          </ButtonWithLoading>
        </div>
      </AdvForm>
    );
  }
}

AccountAddEditView.defaultProps = {
  accountTypeOption: null,
  accountOwnerOption: null,
  canEmployeeMaxContribution: false,
};

AccountAddEditView.propTypes = {
  clientId: createCustomPropType(isNumeric).isRequired,
  workflowId: PropTypes.string.isRequired,
  onCancel: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  accountSimpleSelectChanged: PropTypes.func.isRequired,
  accountInputChanged: PropTypes.func.isRequired,
  accountTypeChanged: PropTypes.func.isRequired,
  contributionTypeChanged: PropTypes.func.isRequired,

  accountTypeOption: PropTypes.number,
  accountOwnersGroups: PropTypes.arrayOf(PropTypes.shape({})).isRequired,

  contributionType: PropTypes.oneOf([DOLLAR_CONTRIBUTION, PERCENTAGE_CONTRIBUTION, NO_CONTRIBUTION])
    .isRequired,
  accountTypesOptions: PropTypes.arrayOf(PropTypes.shape({})).isRequired,

  accountOwnerOption: PropTypes.shape({}),
  accountOwnersOptions: PropTypes.arrayOf(PropTypes.shape({})).isRequired,

  account: PropTypes.shape({
    AccountName: PropTypes.string,
    NonSpecificPositionsValue: PropTypes.string,
    EmployerMultiTierMatch: PropTypes.arrayOf(
      PropTypes.shape({
        Match: PropTypes.string,
        Limit: PropTypes.string,
      }),
    ),
    EmployerNonElectiveContribution: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    EmployerMatchType: PropTypes.number,
    IsOrion: PropTypes.bool,
    AccountType: PropTypes.number,
    GroupId: PropTypes.number,
    SpecificPositionsValue: PropTypes.number,
  }).isRequired,
  graphAccounts: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  groups: PropTypes.arrayOf(PropTypes.shape({})).isRequired,

  contributionLabel: PropTypes.string.isRequired,
  dollarContributionKeyName: PropTypes.string.isRequired,

  percentageContributionTitle: PropTypes.string.isRequired,
  percentageContributionKeyName: PropTypes.string.isRequired,

  isEmployerMatchableRetirementAccount: PropTypes.bool.isRequired,

  mapEmployerMatch: PropTypes.func.isRequired,

  canEmployeeMaxContribution: PropTypes.bool,
  contributionPeriod: PropTypes.number.isRequired,
  hasMaximizeContributions: PropTypes.bool.isRequired,
  hasContributionPeriodOption: PropTypes.bool.isRequired,
  hasContributionPercentOption: PropTypes.bool.isRequired,
};

export default AccountAddEditView;
